export { default as DetailPage } from './Detail';
export { default as ListPage } from './List';
